import React, { useEffect } from 'react';
import { ThemeProvider } from '@emotion/react';
import { useLogger, useSelector } from '~/Hooks';
import getTheme from '../themes/getTheme';

interface Props {
  children: React.ReactNode;
}
const ThemeProviderWrapper = ({ children }: Props) => {
  const companyId = useSelector((state) => state.company);
  const theme = getTheme(companyId);

  const mountLogger = useLogger('mount');

  useEffect(() => {
    mountLogger.info('Mounted: ThemeProviderWrapper');
    return () => {
      mountLogger.info('Unmounted: ThemeProviderWrapper');
    };
  }, []);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default ThemeProviderWrapper;
